document.querySelectorAll('.ModalAuth--step1').forEach((el) => {
    const input = el.querySelector('input');
    el.querySelector('button').addEventListener('click', () => {
        document.querySelector('.ModalAuth--step2 .ModalAuth__subtitle span').innerHTML = input.value;
    })
})
